import React from 'react';
import Layout from '../Shared/Layout';
import {Container, Grid, Paper} from "@material-ui/core";
import styled from "styled-components";
import BarChart from '@material-ui/icons/BarChart';
import Update from '@material-ui/icons/Update';
import SearchIcon from '@material-ui/icons/Search';
import ReorderIcon from '@material-ui/icons/Reorder';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Language from "@material-ui/icons/Language";
import {InertiaLink} from "@inertiajs/inertia-react";
import DescriptionIcon from '@material-ui/icons/Description';
import BackButton from "../Shared/BackButton";

const Card = styled(InertiaLink)`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  text-align: center;
  padding: 30px;
  font-size: 20px;
  display: block;
  text-decoration: none;
  color: ${props => props.theme.text};
  height: 100%;
`;

const Wrapper = styled.div`
`;

const Title = styled.h2`
    color: ${props => props.theme.primary};
`;

export default function AnalyticsOverview({ dashboards }) {
    return (
        <>
            <Container maxWidth="lg">
                <BackButton />
            </Container>
            <Wrapper>
                    <Container maxWidth="lg">
                        <Grid container spacing={3} justify={'center'}>
                            {
                                dashboards.map(item =>
                                    <Grid item xs={12} sm={3}>
                                        <Card href={item.link}>
                                            {
                                                item.icon === 'tat' && <Update style={{fontSize: 50}} color={'secondary'} />
                                            }
                                            {
                                                item.icon === 'volume' && <BarChart style={{fontSize: 50}} color={'secondary'} />
                                            }
                                            <Title>
                                                {
                                                    item.title
                                                }
                                            </Title>
                                            <p style={{fontSize: 16}}>
                                                {
                                                    item.description
                                                }
                                            </p>
                                        </Card>
                                    </Grid>
                                )
                            }
                        </Grid>
                    </Container>
                </Wrapper>
        </>
    )
}

AnalyticsOverview.layout = page => <Layout children={page} />;
